import ContentWrapper from "@/components/Core/ContentWrapper";
import ProductPageCoreInfo from "@/components/ProductPage/ProductPageHero/ProductPageCoreInfo";
import ProductPageGallery from "@/components/ProductPage/ProductPageHero/ProductPageGallery";
import ProductPageSpecifications from "@/components/ProductPage/ProductPageHero/ProductPageSpecifications";
import { PlantTagRecord } from "@/lib/algolia/plantTags";
import { RichSBData } from "./types";
import styled from "styled-components";
import ProductPageResources from "@/components/ProductPage/ProductPageHero/ProductPageResources";
import ProductPageInfoSection from "@/components/ProductPage/ProductPageHero/ProductPageInfoSection";

const ProductPageHeroContainer = styled.div`
  width: 100%;
  padding-top: 76px;
`;

const ProductPageHeroInnerContainerWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ProductPageHeroInnerContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(24, minmax(0, 1fr));
  gap: calc(0.25rem * 4);
  max-width: 1180px;
  @media (max-width: 1000px) {
    padding: 0;
    grid-template-rows: 1fr auto;
    max-width: unset;
  }
`;

const GalleryContainer = styled.div`
  grid-column: span 14 / span 14;
  grid-row-start: 1;
  grid-column-start: 1;
  height: fit-content;
  position: sticky;
  top: 0;
  @media (max-width: 1150px) {
    grid-column: span 7 / span 7;
  }
  @media (max-width: 1000px) {
    grid-column: span 24 / span 24;
    grid-column-start: 1;
    grid-row-start: 1;
    position: relative;
  }
`;

const ProductPageHeroContent = styled.div`
  position: sticky;
  top: 74px;
  height: fit-content;
  grid-column: span 11 / span 11;
  grid-row-start: 1;
  grid-column-start: 16;
  @media (max-width: 1150px) {
    grid-column: span 8 / span 8;
    grid-column-start: 9;
  }
  @media (max-width: 1000px) {
    grid-column: span 24 / span 24;
    grid-column-start: 1;
    grid-row-start: 2;
    padding: 0 16px;
    padding-top: 2rem;
  }
`;

const SectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

interface ProductPageHeroProps {
  record: PlantTagRecord;
  RichSBData: RichSBData;
}

export default function ProductPageHero({ record, RichSBData }: ProductPageHeroProps) {
  console.log(RichSBData);
  return (
    <ProductPageHeroContainer>
      <ContentWrapper noMobilePadding>
        <ProductPageHeroInnerContainerWrapper>
          <ProductPageHeroInnerContainer>
            <GalleryContainer>
              <ProductPageGallery
                images={RichSBData.content.gallery}
                imageURL={record.Image_URL}
                description={record.Description}
              />
            </GalleryContainer>
            <ProductPageHeroContent>
              <ProductPageCoreInfo record={record} RichSBData={RichSBData} />

              <SectionsContainer>
                <ProductPageSpecifications record={record} />
                {RichSBData && RichSBData?.content?.resources?.length > 0 && (
                  <ProductPageResources record={record} RichSBData={RichSBData} />
                )}
                {RichSBData && RichSBData?.content?.infoItems?.length > 0 && (
                  <ProductPageInfoSection record={record} RichSBData={RichSBData} />
                )}
              </SectionsContainer>
            </ProductPageHeroContent>
          </ProductPageHeroInnerContainer>
        </ProductPageHeroInnerContainerWrapper>
      </ContentWrapper>
    </ProductPageHeroContainer>
  );
}
